import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api/client';

export interface AdminPurchase {
    id: number;
    userId: number;
    userEmail: string;
    creditsAdded: number;
    amountPaidCents: number;
    amountFormatted: string;
    paymentStatus: string;
    paymentStatusLabel: string;
    stripeSessionId: string;
    stripePaymentIntentId: string | null;
    metadata: Record<string, unknown>;
    createdAt: string;
    confirmationEmailSentAt: string | null;
}

export interface AdminPurchasesListResponse {
    purchases: AdminPurchase[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
}

export function useAdminPurchases(page = 1, limit = 20) {
    const params = new URLSearchParams({
        page: String(page),
        limit: String(limit),
    });

    return useQuery<AdminPurchasesListResponse>({
        queryKey: ['admin', 'purchases', page, limit],
        queryFn: () => api.get(`/api/admin/credits/purchases?${params}`),
    });
}

export function useResendPurchaseEmail() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (purchaseId: number) =>
            api.post(`/api/admin/credits/purchases/${purchaseId}/resend-email`),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['admin', 'purchases'] });
        },
    });
}
